import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RUNTIME_CONFIG } from '../config/runtime-config';

export interface SmtpConfiguration {
  configured: boolean;
  host: string | null;
  port: number | null;
  security: string | null;
  fromAddress: string | null;
  fromName: string | null;
  authenticationConfigured: boolean;
}

export interface NotificationSystemSettings {
  revision: number;
  maximumEventAgeSeconds: number | null;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface UpdateNotificationSystemSettings {
  expectedRevision: number;
  maximumEventAgeSeconds: number | null;
}

@Injectable({ providedIn: 'root' })
export class NotificationConfigurationApiService {
  private readonly http = inject(HttpClient);
  private readonly base = inject(RUNTIME_CONFIG).notificationApiUrl;

  smtp() {
    return this.http.get<SmtpConfiguration>(`${this.base}/configuration/smtp`);
  }

  systemSettings() {
    return this.http.get<NotificationSystemSettings>(
      `${this.base}/system-settings`,
    );
  }

  updateSystemSettings(settings: UpdateNotificationSystemSettings) {
    return this.http.put<NotificationSystemSettings>(
      `${this.base}/system-settings`,
      settings,
    );
  }
}
